import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { QuickWinSection } from '../components/QuickWinSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-main font-sans text-body" data-id="element-296">
      {/* Navigation / Logo */}
      <nav className="absolute top-0 left-0 w-full p-6 z-50" data-id="element-297">
        <div className="max-w-7xl mx-auto flex justify-center items-center" data-id="element-298">
          <div className="text-xl font-serif font-bold tracking-wider text-title" data-id="element-299">
            MÉTODO FACELESS<span className="text-accent" data-id="element-300">.</span>
          </div>
        </div>
      </nav>

      <main data-id="element-301">
        <HeroSection data-id="element-302" />
        <ProblemSection data-id="element-303" />
        <SolutionSection data-id="element-304" />
        <WhatInsideSection data-id="element-305" />
        <QuickWinSection data-id="element-306" />
        <TestimonialsSection data-id="element-307" />
        <BonusSection data-id="element-308" />
        <PricingSection data-id="element-309" />
        <FAQSection data-id="element-310" />
        <CTASection data-id="element-311" />
      </main>
      <Footer data-id="element-312" />
    </div>;
}